@if (isPrintMode) {
  <rma-static-google-map [markers]="markers" [config]="staticMapConfig" [staticMapUrl]="printedUrl" />
} @else {
  <rma-google-map [padding]="24" [markers]="markers" [options]="interactiveMapOptions" (markerSelected)="markerSelected.emit($event.id)" />
}
